import React from 'react';

export const ModalFooter = ({ children }) => {
    return (
        <>
            <div className="modal-footer">
                {children}
            </div>
        </>
    );
};
